// Single source of truth for payment status display and filtering.
// The backend has 5 payment statuses (SUCCEEDED / FAILED / PENDING / CANCELED / RESERVED),
// but RESERVED is an internal "funds-on-hold" state that we deliberately collapse into
// the existing user-facing "Pending" label. When the user filters by "Pending" we must
// expand back to both PENDING and RESERVED so reserved rows are returned by the API.

export type PaymentStatusUi = 'Succeeded' | 'Failed' | 'Pending' | 'Canceled';

export const PAYMENT_STATUSES_UI: PaymentStatusUi[] = [
	'Succeeded',
	'Failed',
	'Pending',
	'Canceled',
];

export const convertPaymentStatus = (
	backend: string | null | undefined,
): PaymentStatusUi => {
	switch (backend?.toUpperCase()) {
		case 'SUCCEEDED':
			return 'Succeeded';
		case 'FAILED':
			return 'Failed';
		case 'PENDING':
		case 'RESERVED':
			return 'Pending';
		case 'CANCELED':
			return 'Canceled';
		default:
			return 'Failed';
	}
};

export const paymentStatusSeverity = (
	ui: PaymentStatusUi,
): 'success' | 'danger' | 'warning' | 'info' => {
	switch (ui) {
		case 'Succeeded':
			return 'success';
		case 'Failed':
			return 'danger';
		case 'Pending':
			return 'warning';
		case 'Canceled':
			return 'info';
	}
};

export const paymentStatusTextColor = (ui: PaymentStatusUi): string => {
	switch (ui) {
		case 'Succeeded':
			return 'text-success50';
		case 'Failed':
			return 'text-error50';
		case 'Pending':
			return 'text-warning50';
		case 'Canceled':
			return 'text-neutral50';
	}
};

export const expandUiStatusesForFilter = (
	ui: PaymentStatusUi[],
): string[] => {
	const out: string[] = [];
	for (const s of ui) {
		out.push(s.toUpperCase());
		if (s === 'Pending') out.push('RESERVED');
	}
	return out;
};
